/**
 * Date With Weekday
 * Renders a date with its weekday prefix, switching to the short weekday on narrow viewports.
 */

import { formatDateShort, formatDayOfWeek, formatDayOfWeekShort } from "@/lib/utils/formatting";

interface DateWithWeekdayProps {
  date: string;
}

/** Renders "Monday, Jan 5, 2026" on sm+ and "Mon, Jan 5, 2026" below sm. */
export function DateWithWeekday({ date }: DateWithWeekdayProps) {
  return (
    <>
      <span className="hidden sm:inline">{formatDayOfWeek(date)}, </span>
      <span className="sm:hidden">{formatDayOfWeekShort(date)}, </span>
      {formatDateShort(date)}
    </>
  );
}
